import weiShopSetting from './weiShopSetting'
import marketingTools from './marketingTools'
import notice from './notice'
import myShop from './myShop'
import serviceAccount from './serviceAccount'
// import serviceData from './serviceData'
import serviceDistriRule from './serviceDistriRule'
import businessSchool from './businessSchool'
import singleProduct from './singleProduct'
import merchantSupport from './merchantSupport'

export default [
  weiShopSetting,
  marketingTools,
  notice,
  myShop,
  serviceAccount,
  // serviceData,
  serviceDistriRule,
  businessSchool,
  singleProduct,
  merchantSupport
]
